/**
 * This method parse string to integer if it can. If not - it returns null.
 * @param str
 * @returns {*}
 */
export const safeParseInteger = str => {
  if (/^(0|[1-9]\d*)$/.test(str)) {
    return parseInt(str, 10);
  }
  return null;
};

/**
 * This method parse string to number if it can. If not - it returns null.
 * @param str
 * @returns {*}
 */
export const safeParseNumber = str => {
  const parsedNumber = +str;
  if (/^-?(0|0\.\d+|[1-9]\d*|[1-9]\d*\.\d+)$/.test(str)) {
    return parsedNumber;
  }
  return null;
};
